import { render } from "./ProviderAmountSummary.vue?vue&type=template&id=6617be75&scoped=true&ts=true"
import script from "./ProviderAmountSummary.vue?vue&type=script&lang=ts"
export * from "./ProviderAmountSummary.vue?vue&type=script&lang=ts"

import "./ProviderAmountSummary.vue?vue&type=style&index=0&id=6617be75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6617be75"]])

export default __exports__